import React, { useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/auth";

// Componente RouteWrapper que recebe um componente "element" e verifica os papéis (roles) do usuário
const RouteWrapper = ({
    element: Element,
    auth = false,
    roles = [],
    requiredModules = [],
    ...props
}) => {
    const { user, hasEffectiveModule, hasModule } = useAuth(); // Obtém o usuário autenticado através do hook useAuth
    const navigate = useNavigate(); // Hook do React Router para redirecionamento de navegação
    const location = useLocation();

    useEffect(() => {
        if (!user && auth) {
            navigate("/signIn", { replace: true });
            return;
        }

        if (user && Array.isArray(requiredModules) && requiredModules.length > 0) {
            const check = typeof hasEffectiveModule === "function" ? hasEffectiveModule : hasModule;
            const allowed = requiredModules.some((m) => check?.(m));
            if (!allowed) {
                navigate("/no-access", {
                    replace: true,
                    state: { from: `${location.pathname}${location.search || ""}` },
                });
                return;
            }
        }

        // Se o usuário estiver autenticado e os papéis forem fornecidos (não nulos)
        if (user && roles.length > 0) {
            // Verifica se o usuário tem algum dos papéis exigidos (roles)
            const hasRole = user.roles?.some((role) => {
                const name = typeof role === "string" ? role : role?.name;
                return name && roles.includes(name);
            });

            // Se o usuário não tiver um dos papéis exigidos, redireciona para a página inicial
            if (!hasRole) {
                navigate("/reports?model=cashflow", { replace: true });
            }
        }
    }, [auth, hasModule, location.pathname, location.search, navigate, requiredModules, roles, user]); // Executa o efeito quando user, roles ou navigate mudarem

    // Renderiza o componente passado como 'Element' com todas as props adicionais
    return <Element {...props} />;
};

export default RouteWrapper;
